import { useState, useMemo, useEffect } from "react";
import differenceInSeconds from "date-fns/differenceInSeconds";
import { Box } from "@material-ui/core";

import { useSaleBannerStyles } from "./saleBanner.styles";

export const Timer = ({ deadline }: { deadline: Date }) => {
  const classes = useSaleBannerStyles();
  const ONE_DAY = 60 * 60 * 24;
  const ONE_HOUR = 60 * 60;
  const ONE_MINUTE = 60;
  const [currentTime, setCurrentTime] = useState(new Date().getTime());

  const diffInSeconds = differenceInSeconds(deadline, currentTime);

  const getCountdown = () => {
    if (diffInSeconds <= 1) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }
    const days = Math.floor(diffInSeconds / ONE_DAY);
    const hours = Math.floor((diffInSeconds - days * ONE_DAY) / ONE_HOUR);
    const minutes = Math.floor((diffInSeconds - days * ONE_DAY - hours * ONE_HOUR) / ONE_MINUTE);
    const seconds = diffInSeconds - days * ONE_DAY - hours * ONE_HOUR - minutes * ONE_MINUTE;
    return {
      days,
      hours,
      minutes,
      seconds
    };
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const countdown = useMemo(getCountdown, [currentTime]);

  useEffect(() => {
    setInterval(() => {
      const now = new Date().getTime();
      setCurrentTime(now);
    }, 1000);
  }, []);

  return (
    <Box display={"flex"} alignItems={"center"} marginLeft={"6px"} color={"#fff"}>
      <Box className={classes.timeBox}>{countdown.days}</Box>
      <span className={classes.separator}>:</span>
      <Box className={classes.timeBox}>{countdown.hours}</Box>
      <span className={classes.separator}>:</span>
      <Box className={classes.timeBox}> {countdown.minutes}</Box>
      <span className={classes.separator}>:</span>
      <Box className={classes.timeBox}>{countdown.seconds}</Box>
    </Box>
  );
};
